import React, { PropsWithChildren, useMemo } from 'react';
import { LDProvider, ProviderConfig } from 'launchdarkly-react-client-sdk';
import { LDEvaluationDetail } from 'launchdarkly-js-client-sdk';

import { config } from 'common/config';
import { useSelector } from 'react-redux';
import { selectUser, selectUserCompany } from '../../redux/user/selectors';

export function FeatureFlagProvider({ children }: PropsWithChildren) {
  const user = useSelector(selectUser);
  const userCompany = useSelector(selectUserCompany);

  const companyCode = userCompany?.code;
  const userId = user?.id;
  const userEmail = user?.emailAddress;

  const ldUserDetails = useMemo(() => {
    if (!companyCode || !userId || !userEmail) {
      return undefined;
    }

    const isE2eUser = userEmail.includes('e2e');

    if (isE2eUser) {
      return  {
        kind: 'multi',
        company: {
          key: 'BCE2E',
        },
      };
    }

    return  {
      kind: 'multi',
      company: {
        key: companyCode,
      },
    };
  }, [companyCode, userId, userEmail]);

  const providerOptions: ProviderConfig = useMemo(() => {
    return {
      clientSideID: config?.launchDarklyClientId || '',
      deferInitialization: true,
      reactOptions: {
        useCamelCaseFlagKeys: false,
      },
      options: {
        bootstrap: 'localStorage',
        inspectors: [
          {
            type: 'flag-used',
            name: 'dd-inspector',
            method: (key: string, detail: LDEvaluationDetail) => {
              if (window.DD_RUM) {
                window.DD_RUM.addFeatureFlagEvaluation(key, detail.value);
              }
            },
          },
        ],
      },
      context: ldUserDetails,
    } as ProviderConfig
  }, [ldUserDetails]);

  return (
    <LDProvider{...providerOptions}>
        {children}
    </LDProvider>
  );
}
